export default "__VITE_ASSET__5beb41b1__"